export const TEXT_MAX_SIZE = 300
export const REVIEW_COMMENT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'reviews-text'
